import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import NotificationRow from '../notification-row/notification-row';
import ColumnFilterPanel from '../../../../components/column-filter-panel/column-filter-panel';
import './notification-table.scss';

const NotificationTable = ({ notifications, users, selectedUsers, save }) => {
    const [showMemberFilter, setShowMemberFilter] = useState(false);

    const buckets = useMemo(() => {
        const result = {
            today: [],
            yesterday: [],
            lastWeek: [],
            lastMonth: [],
        };
        (notifications ?? []).forEach((notification) => {
            if (notification.section === 'Today') {
                result.today.push(notification);
            } else if (notification.section === 'Yesterday') {
                result.yesterday.push(notification);
            } else if (notification.section === 'Last Week') {
                result.lastWeek.push(notification);
            } else {
                result.lastMonth.push(notification);
            }
        });
        return result;
    }, [notifications]);

    return (
        <Table className="notification-table">
            <thead>
                <tr>
                    <th className="read-column"></th>
                    <th className="sender-column">
                        <div className="table-header">
                            Sender
                            <ColumnFilterPanel
                                key={JSON.stringify(users)}
                                list={users} selected={selectedUsers} save={save}
                                type="Members" idParameter="Id" nameParameter="Name" listName="users" column="createdBy" value="creatorIDs"
                                filteredListName="createdBy"
                                show={showMemberFilter} close={() => setShowMemberFilter(false)}
                                change={() => setShowMemberFilter((prev) => !prev)}
                                className="project-selection-panel"
                            />
                        </div>
                    </th>

                    <th className="description-column">Description</th>
                    <th className="time-column">Time</th>
                </tr>
            </thead>
            <tbody>
                {   Array.isArray(buckets.today) && buckets.today.length ?
                    <>
                        <tr className="notification-row divider">
                            <td className="read-column"></td>
                            <td className="sender-row">Today</td>
                            <td></td>
                            <td></td>
                        </tr>
                        {buckets.today.map((notification) => (
                            <NotificationRow key={notification.notificationId} notification={notification} />
                        ))}
                    </>
                    : <></>
                }
                {   Array.isArray(buckets.yesterday) && buckets.yesterday.length ?
                    <>
                        <tr className="notification-row divider">
                            <td className="read-column"></td>
                            <td className="sender-row">Yesterday</td>
                            <td></td>
                            <td></td>
                        </tr>
                        {buckets.yesterday.map((notification) => (
                            <NotificationRow key={notification.notificationId} notification={notification} />
                        ))}
                    </>
                    : <></>
                }
                {   Array.isArray(buckets.lastWeek) && buckets.lastWeek.length ?
                    <>
                        <tr className="notification-row divider">
                            <td className="read-column"></td>
                            <td className="sender-row">Last Week</td>
                            <td></td>
                            <td></td>
                        </tr>
                        {buckets.lastWeek.map((notification) => (
                            <NotificationRow key={notification.notificationId} notification={notification} />
                        ))}
                    </>
                    : <></>
                }
                {   Array.isArray(buckets.lastMonth) && buckets.lastMonth.length ?
                    <>
                        <tr className="notification-row divider">
                            <td className="read-column"></td>
                            <td className="sender-row">{buckets.lastMonth[0].author !== null ? "Last Month" : "No Notifications"}</td>
                            <td></td>
                            <td></td>
                        </tr>
                        {   buckets.lastMonth[0].author !== null &&
                            buckets.lastMonth.map((notification) => (
                                <NotificationRow key={notification.notificationId} notification={notification} />
                            ))
                        }
                    </>
                    : <></>
                }
            </tbody>
        </Table>
    );
};

NotificationTable.propTypes = {
    notifications: PropTypes.array,
    users: PropTypes.array,
    selectedUsers: PropTypes.array,
    save: PropTypes.func,
};

export default NotificationTable;
